import { useState } from 'react';
import { gql, useMutation } from '@apollo/client';
import { Box, Button } from '@mui/material';
import RealtorForm from '../common/forms/RealtorForm';
import { IRealtorInfo } from '../../types/CreateDealForm';
import { FlexBetween } from '../../commonStyles';
import { useAppDispatch } from '../../app/hooks';
import { showErrorSnackbar, showSuccessSnackbar } from '../../features/snackbar/snackbarSlice';
import { formatPhoneNumber } from '../../utils/Functions';
import { PHONE_FIELDS, REQUIRED_FIELDS } from './RealtorDetails';

const emptyRealtor: any = {
  firstName: '',
  lastName: '',
  brokerage: '',
  email: '',
  streetAddress: '',
  city: '',
  province: '',
  country: '',
  postalCode: '',
  brokeragePhone: '',
  brokerageFax: '',
  directPhone: '',
};

// Creates a new realtor from the worksheet page, for when they aren't in the realtor dropdown yet
const NewRealtor = (props: ChildProps) => {
  const { onCreated, onCancel } = props;
  const storeDispatch = useAppDispatch();
  const [draft, setDraft] = useState<IRealtorInfo>(emptyRealtor);

  const [createRealtor, { loading }] = useMutation(CREATEREALTOR, {
    onCompleted: (data) => {
      onCreated(data.realtorCreateOne.record);
      storeDispatch(showSuccessSnackbar('Realtor has been created!'));
    },
    onError: (error) => {
      storeDispatch(showErrorSnackbar(error.message));
    },
  });

  const handleTextInput = (event: any) => {
    const { id, value } = event.target;
    setDraft({ ...draft, [id]: PHONE_FIELDS.includes(id) ? formatPhoneNumber(value) : value });
  };

  const handleCreate = () => {
    if (REQUIRED_FIELDS.some((field) => !draft[field])) {
      storeDispatch(showErrorSnackbar('Please complete all required realtor fields'));
      return;
    }
    createRealtor({ variables: { record: draft } });
  };

  return (
    <Box sx={{ mt: 2 }}>
      <RealtorForm realtorInfo={draft} handleTextInput={handleTextInput} />
      <FlexBetween sx={{ mt: 2 }}>
        <Button color="success" variant="contained" disabled={loading} onClick={handleCreate}>
          Create Realtor
        </Button>
        <Button variant="contained" disabled={loading} onClick={onCancel}>
          Cancel
        </Button>
      </FlexBetween>
    </Box>
  );
};

interface ChildProps {
  onCreated: (realtor: IRealtorInfo) => void;
  onCancel: () => void;
}

const CREATEREALTOR = gql`
  mutation realtorCreateOne($record: CreateOneRealtorInput!) {
    realtorCreateOne(record: $record) {
      record {
        _id
        email
        firstName
        lastName
        fullName
        brokerage
        streetAddress
        city
        province
        country
        postalCode
        brokeragePhone
        brokerageFax
        directPhone
        disable
      }
    }
  }
`;

export default NewRealtor;
